/** Escape de HTML/atributos e helper de template tag. */
const HTML_ENTITIES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
};
export function escapeHtml(value) {
    if (value === null || value === undefined)
        return "";
    return String(value).replace(/[&<>"']/g, (c) => HTML_ENTITIES[c]);
}
/** Para uso em `href`/`src`. Bloqueia `javascript:` e afins. */
export function safeUrl(value) {
    const s = String(value ?? "").trim();
    if (/^(https?:|mailto:|tel:|\/|#)/i.test(s))
        return escapeHtml(s);
    return "";
}
/** String já sanitizada — não passa de novo pelo escape. */
export class RawHtml {
    value;
    constructor(value) {
        this.value = value;
    }
    toString() {
        return this.value;
    }
}
export function raw(input) {
    return input instanceof RawHtml ? input : new RawHtml(input);
}
function part(v) {
    if (v === null || v === undefined || v === false)
        return "";
    if (v instanceof RawHtml)
        return v.value;
    if (Array.isArray(v))
        return v.map(part).join("");
    return escapeHtml(v);
}
/**
 * Tag de template: escapa cada valor interpolado por padrão. Valores que já são
 * `RawHtml` (inclusive o resultado de outro `html\`\``) entram sem re-escape,
 * então dá pra compor fragmentos livremente.
 */
export function html(strings, ...values) {
    let out = strings[0] ?? "";
    for (let i = 0; i < values.length; i++) {
        out += part(values[i]);
        out += strings[i + 1] ?? "";
    }
    return new RawHtml(out);
}
//# sourceMappingURL=escape.js.map